import type { SoftUpdatePlanRequestPayload, SoftUpdatePlanResponse } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { invalidatePlansQueries } from '../../utils/query-invalidation';

export function useSoftUpdatePlan(
  planId: string,
  options?: UseMutationOptions<SoftUpdatePlanResponse, unknown, SoftUpdatePlanRequestPayload>,
) {
  const queryClient = useQueryClient();

  return useMutation(
    ['updateSoftPlan'],
    (softPlanInput) => {
      const api = getPrivateApi();

      return api.softUpdatePlan({
        planId,
        softUpdatePlanRequest: softPlanInput,
      });
    },
    {
      onSuccess: async () => {
        await invalidatePlansQueries(queryClient);
      },
      ...options,
    },
  );
}
